const titleClick=(id)=>{
    if(id==11){
      navigateTo(`/about`)
    }else if(id==22){
      navigateTo(`/product`)
    }else if(id==33){
      navigateTo(`/health`)
    }else if(id==44){
      navigateTo(`/contact`)
    }else if(id==55){
      navigateTo(`/newsCenter`)
    }
  }
  const menuClick =(e,path,setActive)=>{
    let id = +e
    navigateTo(path)
    if(path=='/about' && typeof setActive === 'function'){
      setActive(+id-1)
      return
    }
    if(path=='/product' && typeof setActive === 'function'){
      setActive(+id-6)
      return
    }
    if(path=='/health' && typeof setActive === 'function'){
      setActive(0)
      return
    }
    if(path=='/contact' && typeof setActive === 'function'){
      setActive(+id-13)
      return
    }
  }

  export default{
    titleClick,
    menuClick
  }